// extracted by mini-css-extract-plugin
export default {"product_container":"Productlist_product_container__odaXt","sort_container":"Productlist_sort_container__bVMBj","products_box":"Productlist_products_box__3AFAx"};